import React, { useState } from 'react';
import { ArrowRight, X } from 'lucide-react';

// Sample project data
const projectGallery = [
  // Residential Building (5 projects)
  {
    id: 1,
    title: 'Modern Residential Complex',
    category: 'Residential Building',
    location: 'Pune City Center',
    year: '2023',
    description: 'Luxury apartments with modern amenities and sustainable design',
    image: 'assets/R1-min.jpg', // Replace with your actual image path
  },
  {
    id: 2,
    title: 'Elegant Apartments',
    category: 'Residential Building',
    location: 'Baner',
    year: '2022',
    description: 'Premium apartments with modern architecture and greenery.',
    image: 'assets/R2-min.jpg',
  },
  {
    id: 3,
    title: 'Suburban Villas',
    category: 'Residential Building',
    location: 'Hinjewadi',
    year: '2021',
    description: 'Spacious villas for family living.',
    image: 'assets/R3-min.jpg',
  },
  {
    id: 4,
    title: 'Luxury Homes',
    category: 'Residential Building',
    location: 'Wakad',
    year: '2023',
    description: 'Exclusive homes with premium facilities.',
    image: 'assets/R4-min.jpg',
  },
  {
    id: 5,
    title: 'Skyline Tower',
    category: 'Residential Building',
    location: 'Aundh',
    year: '2023',
    description: 'High-rise apartments with a view.',
    image: 'assets/R5-min.jpg',
  },

  // Commercial Building (5 projects)
  {
    id: 6,
    title: 'Commercial Plaza',
    category: 'Commercial Building',
    location: 'Pimple Nilakh',
    year: '2023',
    description: 'State-of-the-art commercial space with premium facilities.',
    image: 'assets/C1-min.jpg',
  },
  {
    id: 7,
    title: 'Downtown Office Space',
    category: 'Commercial Building',
    location: 'Koregaon Park',
    year: '2022',
    description: 'Corporate offices with modern infrastructure.',
    image: 'assets/C2-min.jpg',
  },
  {
    id: 8,
    title: 'Retail Arcade',
    category: 'Commercial Building',
    location: 'Magarpatta',
    year: '2021',
    description: 'Retail and shopping space with easy accessibility.',
    image: 'assets/C3-min.jpg',
  },
  {
    id: 9,
    title: 'Urban Trade Center',
    category: 'Commercial Building',
    location: 'Kothrud',
    year: '2022',
    description: 'Commercial complex with innovative designs.',
    image: 'assets/C4-min.jpg',
  },
  {
    id: 10,
    title: 'Prime Offices',
    category: 'Commercial Building',
    location: 'Viman Nagar',
    year: '2023',
    description: 'Sophisticated office space in a prime location.',
    image: 'assets/C5-min.jpg',
  },

  // Industrial Construction (5 projects)
  {
    id: 11,
    title: 'Advanced Factory Unit',
    category: 'Industrial Construction',
    location: 'Chakan',
    year: '2022',
    description: 'Modern industrial facility for manufacturing.',
    image: 'assets/I1-min.jpg',
  },
  {
    id: 12,
    title: 'Warehouse Hub',
    category: 'Industrial Construction',
    location: 'Ranjangaon',
    year: '2021',
    description: 'Spacious warehouse with advanced logistics.',
    image: 'assets/I2.jpg',
  },
  {
    id: 13,
    title: 'Production Plant',
    category: 'Industrial Construction',
    location: 'Talegaon',
    year: '2022',
    description: 'High-capacity production facility.',
    image: 'assets/I3.jpg',
  },
  {
    id: 14,
    title: 'Blueberry Stalk',
    category: 'Industrial Construction',
    location: 'Nigdi',
    year: '2022',
    description: 'Advanced infrastructure for Shopping.',
    image: 'assets/I6.jpg',
  },
  {
    id: 15,
    title: 'Logistics Park',
    category: 'Industrial Construction',
    location: 'Nigdi',
    year: '2022',
    description: 'Advanced infrastructure for logistics.',
    image: 'assets/I5.jpg',
  },

  // Water Tank (5 projects)
  {
    id: 16,
    title: 'Underground Reservoir',
    category: 'Water Tank',
    location: 'Hadapsar',
    year: '2021',
    description: 'Large underground water reservoir.',
    image: 'assets/W1.jpg',
  },
  {
    id: 17,
    title: 'Elevated Water Tank',
    category: 'Water Tank',
    location: 'Kondhwa',
    year: '2023',
    description: 'High-capacity water storage tank.',
    image: 'assets/W2.jpg',
  },
  {
    id: 18,
    title: 'Municipal Water Storage',
    category: 'Water Tank',
    location: 'Warje',
    year: '2022',
    description: 'Public water storage facility.',
    image: 'assets/W3.jpg',
  },
  {
    id: 19,
    title: 'Irrigation Tank',
    category: 'Water Tank',
    location: 'Saswad',
    year: '2022',
    description: 'Water storage tank for irrigation.',
    image: 'assets/W4.jpg',
  },
  {
    id: 20,
    title: 'Overhead Storage',
    category: 'Water Tank',
    location: 'Hadapsar',
    year: '2021',
    description: 'Large underground water reservoir.',
    image: 'assets/W5.jpg',
  },

  // Retaining Wall (5 projects)
  {
    id: 21,
    title: 'Roadside Retaining Wall',
    category: 'Retaining Wall',
    location: 'Pune-Bangalore Highway',
    year: '2021',
    description: 'Structural retaining wall for highways.',
    image: 'assets/D1.jpg',
  },
  {
    id: 22,
    title: 'Garden Retaining Wall',
    category: 'Retaining Wall',
    location: 'Kalyani Nagar',
    year: '2022',
    description: 'Decorative retaining wall for gardens.',
    image: 'assets/D2.jpg',
  },
  {
    id: 23,
    title: 'Slope Stabilization Wall',
    category: 'Retaining Wall',
    location: 'Sinhagad Fort',
    year: '2022',
    description: 'Retaining wall for slope stability.',
    image: 'assets/D3.jpg',
  },
  {
    id: 24,
    title: 'Basement Retaining Wall',
    category: 'Retaining Wall',
    location: 'Camp Area',
    year: '2023',
    description: 'Strong retaining wall for basements.',
    image: 'assets/D4.jpg',
  },
  {
    id: 25,
    title: 'Basement Retaining Wall',
    category: 'Retaining Wall',
    location: 'Camp Area',
    year: '2023',
    description: 'Strong retaining wall for foundation.',
    image: 'assets/D5.jpg',
  },
];

const categories = ['Residential Building', 'Commercial Building', 'Industrial Construction', 'Water Tank', 'Retaining Wall'];

const ProjectGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProject, setSelectedProject] = useState<typeof projectGallery[0] | null>(null);

  // Get filtered projects and limit to top 5
  const filteredProjects = selectedCategory === 'All'
    ? projectGallery.slice(0, 5) // Top 5 across all categories
    : projectGallery.filter((project) => project.category === selectedCategory).slice(0, 5); // Top 5 in the selected category

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-wrap gap-4 justify-center mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full transition-all duration-300 border-2 ${
                selectedCategory === category
                  ? 'bg-blue-600 text-white shadow-lg transform scale-105 border-blue-600'
                  : 'bg-white text-gray-600 hover:bg-blue-50 border-gray-300 hover:border-blue-500'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="gallery-grid grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="gallery-item cursor-pointer"
              onClick={() => setSelectedProject(project)}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-64 object-cover rounded-lg shadow-md"
              />
              <div className="gallery-overlay flex flex-col justify-end p-4 bg-black bg-opacity-50 rounded-lg">
                <h3 className="text-white text-xl font-bold mb-1">{project.title}</h3>
                <p className="text-blue-300">{project.category}</p>
                <p className="text-blue-100 text-sm">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Project Modal */}
      {selectedProject && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <button
                onClick={() => setSelectedProject(null)}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-96 object-cover rounded-t-lg"
              />
              <div className="p-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">{selectedProject.title}</h2>
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <p className="text-gray-600">Category</p>
                    <p className="font-semibold">{selectedProject.category}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Location</p>
                    <p className="font-semibold">{selectedProject.location}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Year</p>
                    <p className="font-semibold">{selectedProject.year}</p>
                  </div>
                </div>
                <p className="text-gray-700">{selectedProject.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectGallery;
